import React, {useCallback, useEffect, useState} from 'react';
import { TextField, Icon, Popover, ActionList } from '@shopify/polaris';
import { ChevronDownMinor} from '@shopify/polaris-icons';
import HTMLIcon from '@admin/pages/Chart/icons/HTMLIcon';
import DressIcon from '@admin/pages/Chart/icons/DressIcon';
import TextIcon from '@admin/pages/Chart/icons/TextIcon';
import ImageIcon from '@admin/pages/Chart/icons/ImageIcon';

interface Cell {
    type: string;
    value: string;
}

interface CTableCellProps {
    cell: Cell;
    isHeader?: boolean;
    onChange: (cell: Cell) => void;
    isPopoverActive: (status: boolean) => void;
}

const CTableCell: React.FC<CTableCellProps> = ({ cell, isHeader, onChange, isPopoverActive }) => {
    const [popoverActive, setPopoverActive] = useState(false);

    useEffect(() => {
        isPopoverActive(popoverActive);

    }, [popoverActive]);


    const changeValue = (value: string) => {
        checkImage(cell.type, value);
        onChange({ ...cell, value });
    };

    const changeType = (type: string) => {
        setPopoverActive(false);
        onChange({ ...cell, type });
    };

    const checkImage = (type: string, value: string) => {
        if (type === 'img' && value === '') {
            alert('Please enter an image URL');
        }
    };

    const cellPlaceholder = () => {
        switch (cell.type) {
            case 'img':
                return 'Shopify image URL';
            case 'html':
                return 'HTML code';
            default:
                return 'Text';
        }
    };

    const iconSource = () => {
        switch (cell.type) {
            case 'text':
                return <TextIcon />;
            case 'dress':
                return <DressIcon/>;
            case 'img':
                return <ImageIcon/>;
            case 'html':
                return <HTMLIcon/>;
            default:
                return '';
        }
    };
    
    const togglePopoverActive = useCallback(
        () => setPopoverActive((popoverActive) => !popoverActive),
        [],
    );
    const activator = (
        <div style={{marginRight: '8px', cursor: 'pointer', paddingTop: '4px'}} onClick={() => setPopoverActive(!popoverActive)}>
            {iconSource()}
        </div>
    );

    return (
        <div
            className={`c-table-cell ${popoverActive ? 'c-table-cell--active' : ''} ${isHeader ? 'c-table-cell--header' : ''}`}>
            <div style={{display: 'flex', alignItems: 'center', width: '100%', border: '2px solid rgb(219, 219, 219)', paddingLeft: '3px', borderRadius: '10px 10px 10px 10px'}}>
                <Popover active={popoverActive} onClose={() => setPopoverActive(false)} activator={activator}>
                    <ActionList
                        items={[
                            {content: 'Text/Number', onAction: () => changeType('text'), active: cell.type === 'text'},
                            {content: 'Dress Size', onAction: () => changeType('dress'), active: cell.type === 'dress'},
                            {content: 'Image', onAction: () => changeType('img'), active: cell.type === 'img'},
                            {content: 'HTML', onAction: () => changeType('html'), active: cell.type === 'html'},
                        ]}
                    />
                </Popover>
                <div style={{marginRight: '8px', cursor: 'pointer'}} onClick={() => setPopoverActive(!popoverActive)}>
                    <Icon source={ChevronDownMinor}/>
                </div>
                <div style={{width: '80%'}}>
                    <TextField
                        label="Data"
                        labelHidden
                        value={cell.value}
                        placeholder={cell.type}
                        onChange={(newValue) => changeValue(newValue)}
                        autoComplete="off"
                    />
                </div>


            </div>
        </div>
    );
};

export default CTableCell;
